import Navbar from '../Components/NavBarAirbnbStyle';
import Footer from '../Components/footer';
import provinciasData from '../data/ciudades.json';
import './space.css'
import { useNavigate } from 'react-router-dom';
import Modal from 'react-modal';

import React, { useState, useEffect, useRef } from 'react';
import { MapContainer, TileLayer, Marker, useMapEvents, useMap } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import { db, auth, storage, } from '../Firebase/Firebase'; // Importa tu configuración de Firebase
import { getDoc, getDocs, collection, setDoc, doc, Timestamp, updateDoc, deleteDoc, where, query } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL, deleteObject } from "firebase/storage";
import { getAuth } from "firebase/auth";

// Importa la imagen del icono que quieres usar para la ubicación
import iconoUbicacion from '../img/ubicacionMap.png'; // Reemplaza con la ruta de tu icono

// Icono para la ubicación del clic
import iconoClic from '../img/ubicacionMap.png'; // Reemplaza con la ruta de tu icono de clic
import axios from 'axios'; // Asegúrate de importar axios correctamente
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// Crear un icono personalizado para la ubicación actual
const iconoUbicacionPersonalizado = new L.Icon({
    iconUrl: iconoUbicacion,
    iconSize: [45, 45], // Tamaño del icono
    iconAnchor: [16, 32], // Punto de anclaje del icono en las coordenadas
});

const Space = () => {
    const [marcas, setMarcas] = useState([]);
    const [marcaSeleccionada, setMarcaSeleccionada] = useState("");
    const [logoSeleccionado, setLogoSeleccionado] = useState("");
    const [provinciaId, setProvinciaId] = useState('');
    const [ciudadId, setCiudadId] = useState('Quito');
    const provinciaSeleccionada = provinciasData.find(p => p.id === parseInt(provinciaId));
    const ciudades = provinciaSeleccionada ? provinciaSeleccionada.cities : [];
    // Mapa de ciudades y sectores
    const[lugares, setLugares] = useState([]);
    const sectoresPorCiudad = {
        "QUITO": [
            "Centro Histórico",
            "La Mariscal",
            "La Carolina",
            "Cumbayá",
            "El Condado",
            "Carapungo",
            "Tumbaco",
            "El Inca",
            "Calderón",
            "Carcelén",
            "Ponceano",
            "Cotocollao",
            "La Floresta",
            "González Suárez",
            "Quito Tenis",
            "La Pradera",
            "Bellavista",
            "El Batán",
            "Chillogallo",
            "La Magdalena",
            "Quitumbe",
            "El Recreo",
            "Solanda",
            "La Ecuatoriana",
            "San Roque",
            "San Juan",
            "El Tejar",
            "San Juan de Cumbayá",
            "Nayón",
            "Lumbisí",
            "San Rafael",
            "Conocoto",
            "La Armenia",
            "Fajardo",
            "Tingo María",
            "La Loma"
        ],
        "GUAYAQUIL": ["Samborondón", "Urdesa", "Ceibos", "Centro", "Las Peñas", "Mapasingue", "Durán", "Alborada"],
        "CUENCA": ["El Vergel", "El Centro", "Totoracocha", "Baños", "Monay", "Yanuncay", "San Joaquín", "Misicata"],
        "AMBATO": ["Centro", "Atocha", "Ficoa", "Miraflores", "Ingahurco", "Huachi Chico", "La Merced"],
        "MANTA": ["Tarqui", "El Murciélago", "Los Esteros", "La Pradera", "San Mateo", "Cuba Libre", "Barbasquillo"],
        "PORTOVIEJO": ["El Florón", "Andrés de Vera", "San Alejo", "Ciudadela Universitaria", "24 de Mayo", "Francisco Pacheco"],
        "LOJA": ["San Sebastián", "El Valle", "Ciudad Victoria", "Punzara", "Carigán", "Jipiro", "La Argelia"],
        "ESMERALDAS": ["Centro", "5 de Agosto", "San Rafael", "La Propicia", "Las Palmas", "La Concordia", "Tachina"],
        "MACHALA": ["9 de Mayo", "El Cambio", "Puerto Bolívar", "Primera Zona", "La Ferroviaria", "La Florida"],
        "RIOBAMBA": ["Loma de Quito", "Santa Rosa", "Capulispamba", "Bellavista", "La Politécnica", "Parque Industrial"],
        "IBARRA": ["Centro Histórico", "El Retorno", "Azaya", "Caranqui", "Yacucalle", "La Esperanza"],
        "SANTO DOMINGO": ["Abelardo Montalvo", "La Concordia", "Plan de Vivienda", "Tsáchilas", "Río Verde", "Los Rosales"],
        "BABAHOYO": ["El Mamey", "La Ventura", "La Chorrera", "Caracol", "Camilo Ponce", "Ciudadela Universitaria"],
        "QUEVEDO": ["San Camilo", "7 de Octubre", "24 de Mayo", "El Guayacán", "Los Guayacanes", "Los Ángeles"],
        "TULCÁN": ["El Rosario", "La Floresta", "Santa Clara", "San Gabriel", "Ciudadela del Norte"],
        "LATACUNGA": ["San Felipe", "El Salto", "Ignacio Flores", "La Laguna", "Centro", "La Estación"],
        "OTAVALO": ["Peguche", "Ilumán", "Cotama", "San Pablo", "Monserrath", "El Jordán"],
        "MILAGRO": ["El Bosque", "12 de Octubre", "Los Vergeles", "Las Piñas", "Río Bonito", "San Francisco"],
        "DURAN": ["El Recreo", "Divino Niño", "Panorama", "La Ferroviaria", "Orquídeas", "Venecia"],
        "TENA": ["San Juan", "San José", "Las Palmas", "Misahuallí", "Puerto Napo", "Unión Base"],
        "NUEVA LOJA": ["La Primavera", "La Mariscal", "El Dorado", "12 de Octubre", "San Sebastián", "Las Palmas"],
        "ZAMORA": ["El Centro", "Zumbi", "Yantzaza", "Cumbaratza", "San Francisco", "La Pituca"],
        "SANTA ELENA": ["La Libertad", "Ballenita", "Salinas", "Punta Carnero", "Anconcito", "Ayangue"],
        "PLAYAS": ["Villamil", "San Antonio", "El Arenal", "Data de Posorja", "Posorja", "Progreso"],
        "PUYO": ["El Recreo", "Pomona", "Fatima", "Mera", "Shell", "Las Américas", "Tena"],
        "Ciudad desconocida": [], // Opcional: Para manejar casos donde no se detecte la ciudad
    };
    const navigate = useNavigate();


    const [userLocation, setUserLocation] = useState(null);
    const mapRef = useRef();
    const [clickPosition, setClickPosition] = useState(null);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [ciudadLugar, setCiudadLugar] = useState('');
    const [sector, setSector] = useState('');
    const [nombreLugar, setNombreLugar] = useState('');
    const [idLugar, setIdLugar] = useState('');
    const [registeredLocations, setRegisteredLocations] = useState([]); // Estado para las ubicaciones registradas
    const [selectedLocation, setSelectedLocation] = useState(null); // Guardar la ubicación seleccionada
    const [modalIsOpenUpdate, setModalIsOpenUpdate] = useState(false);
    const [deleteModalIsOpen, setDeleteModalIsOpen] = useState(false); // Modal de verificación de eliminación
    const closeDeleteModal = () => setDeleteModalIsOpen(false);
    const [usuario, setUsuario] = useState(null);
    const [searchNombreLugar, setSearchNombreLugar] = useState(''); // Nuevo estado para buscar por nombre
    const [sectores, setSectores] = useState([]); // Lista de sectores dinámicos
    const [otroSector, setOtroSector] = useState(false);
    const [selectedCity, setSelectedCity] = useState('');
    const [selectedSector, setSelectedSector] = useState('');
    const [city, setCity] = useState("Quito");
    const [locations, setLocations] = useState([]); // Ubicaciones originales
    const [filteredLocations, setFilteredLocations] = useState([]); // Ubicaciones filtradas
    const [ciudad, setCiudad] = useState(""); // Ciudad seleccionada

    const [direccion, setDireccion] = useState('');
    const [imageFile, setImageFile] = useState(null);

    const obtenerMarcasUsuario = async () => {
        const auth = getAuth();
        const usuario = auth.currentUser;

        if (!usuario) {
            console.error("No hay usuario autenticado");
            return;
        }

        const uid = usuario.uid;
        const usuarioRef = doc(db, "usuarios", uid);

        try {
            const docSnap = await getDoc(usuarioRef);

            if (docSnap.exists()) {
                const usuarioData = docSnap.data();
                if (usuarioData.marcas) {
                    const marcaIds = usuarioData.marcas; // IDs de las marcas
                    const marcasConNombres = await obtenerNombresMarcas(marcaIds);
                    setMarcas(marcasConNombres); // Almacenar marcas con nombres
                    if (marcasConNombres.length === 1) {
                        setMarcaSeleccionada(marcasConNombres[0].id); // Seleccionar por defecto si solo hay una marca
                        setLogoSeleccionado(marcasConNombres[0].logo); // Mostrar logo por defecto
                    }
                } else {
                    console.log("El usuario no tiene marcas asociadas");
                }
            } else {
                console.error("No se encontró el documento del usuario");
            }
        } catch (error) {
            console.error("Error al recuperar marcas:", error);
        }
    };

    // Obtener nombres de las marcas con los IDs
    const obtenerNombresMarcas = async (marcaIds) => {
        const marcasConNombres = [];
        for (const id of marcaIds) {
            const marcaRef = doc(db, "marca", id);
            const marcaSnap = await getDoc(marcaRef);
            if (marcaSnap.exists()) {
                const marcaData = marcaSnap.data();
                marcasConNombres.push({
                    id: id,
                    nombre: marcaData.nombre, // Asumiendo que la marca tiene un campo "nombre"
                    logo: marcaData.logo, // Suponiendo que la marca tiene un campo "logo"
                });
            }
        }
        return marcasConNombres;
    };
    const obtenerLugaresPorMarca = async (marcaId) => {
        try {
          const marcaRef = doc(db, "marca", marcaSeleccionada); // Referencia al documento de la marca
          const lugaresRef = collection(marcaRef, "lugar"); // Subcolección "lugar"
          const lugaresSnap = await getDocs(lugaresRef);
      
          const lugares = lugaresSnap.docs.map(doc => ({
            id: doc.id,
            ...doc.data(),
          }));
      
          console.log("Lugares encontrados:", lugares);
          return lugares;
      
        } catch (error) {
          console.error("Error al obtener los lugares:", error);
          return [];
        }
      };
      useEffect(() => {
        if (marcaSeleccionada) {
          obtenerLugaresPorMarca(marcaSeleccionada).then((lugares) => {
            setLugares(lugares); // Guardas en el estado
          });
        }
      }, [marcaSeleccionada]);
    const fetchLocations = async () => {
        try {
            // Obtener el ID del usuario actual desde localStorage
            const currentUserId = localStorage.getItem('currentUserId');

            if (!currentUserId) {
                toast.error("No se encontró el ID del usuario en localStorage.");
                return;
            }

            // Obtener el rol del usuario actual desde Firestore
            const userDocRef = doc(db, "usuarios", currentUserId);
            const userDocSnap = await getDoc(userDocRef);

            if (!userDocSnap.exists()) {
                console.error("No se encontró el usuario en Firestore.");
                return;
            }

            const currentUser = userDocSnap.data();
            const currentUserRole = currentUser.role;

            console.log(`Rol del usuario actual: ${currentUserRole}`);

            let querySnapshot;
            if (currentUserRole === "admin") {
                // Si el rol es "admin", obtener todas las ubicaciones
                querySnapshot = await getDocs(collection(db, "lugar"));
            } else if (currentUserRole === "prov") {
                // Si el rol es "prov", obtener solo las ubicaciones creadas por este usuario
                const q = query(collection(db, "lugar"), where("createdBy", "==", currentUserId));
                querySnapshot = await getDocs(q);
            } else {
                console.warn("Rol desconocido, no se aplicará ningún filtro.");
                return;
            }

            // Mapear las ubicaciones obtenidas
            const locationsArray = querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
            setLocations(locationsArray); // Guardar todas las ubicaciones
            setFilteredLocations(locationsArray); // Mostrar las ubicaciones filtradas

            console.log("Ubicaciones filtradas:", locationsArray);
        } catch (error) {
            console.error("Error al obtener las ubicaciones:", error);
        }
    };


    useEffect(() => {
        fetchLocations();
    }, []);

    useEffect(() => {
        // Filtrar ubicaciones según la ciudad y el sector seleccionados
        const filtered = locations.filter((location) => {
            const matchesCity = city === "todas" || location.CiudadLugar === city;
            const matchesSector = sector ? location.Sector === sector : true;
            return matchesCity && matchesSector;
        });
        setFilteredLocations(filtered);
    }, [city, sector, locations]);

    // Obtener ciudades únicas con ubicaciones registradas
    const availableCities = Array.from(
        new Set(locations.map((location) => location.CiudadLugar))
    );

    // Generar sectores según la ciudad seleccionada
    const availableSectors =
        city && locations
            .filter((location) => location.CiudadLugar === city)
            .map((location) => location.Sector);


    // Función para manejar clics en el mapa (para agregar un marcador adicional)
    const handleMapClick = (event) => {
        const { lat, lng } = event.latlng;
        setClickPosition({ lat, lng });
    };

    // Función para manejar la selección de la ciudad
    const handleCityChange = (e) => {
        const city = e.target.value;
        setSelectedCity(city);
        setSelectedSector(''); // Reinicia el sector cuando cambia la ciudad
    };

    // Función para manejar la selección del sector
    const handleSectorChange = (e) => {
        setSelectedSector(e.target.value);
    };
    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((user) => {
            if (user) {
                setUsuario(user); // Establece el usuario autenticado
            } else {
                setUsuario(null);
            }
        });

        return () => unsubscribe();
    }, []);
    const openModal = () => {
        setModalIsOpen(true);
        // Limpiar los campos del modal al abrir
        setCiudadLugar('');
        setSector('');
        setNombreLugar('');
        setIdLugar(''); // Reiniciar el ID
    };
    const closeModal = () => {
        setModalIsOpen(false);
    };
    const generateRandomId = () => {
        return 'lugar_' + Math.random().toString(36).substr(2, 9);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (clickPosition && usuario) {
            const newIdLugar = generateRandomId(); // Generar un ID único para el lugar
            const timestamp = Timestamp.now(); // Timestamp actual
            const createdByUserId = localStorage.getItem('currentUserId'); // Obtener el ID del usuario autenticado

            let imageUrl = ""; // Variable para almacenar la URL de la imagen

            if (imageFile) { // Verificar si se seleccionó un archivo de imagen
                try {
                    // Crear una referencia al archivo en Firebase Storage
                    const storageRef = ref(storage, `imagenesLugares/${newIdLugar}`);

                    // Subir el archivo al almacenamiento
                    await uploadBytes(storageRef, imageFile);

                    // Obtener la URL pública de la imagen subida
                    imageUrl = await getDownloadURL(storageRef);
                } catch (error) {
                    console.error("Error subiendo la imagen: ", error);
                    toast.error("Hubo un problema subiendo la imagen.");
                    return;
                }
            }

            const newData = {
                createdBy: createdByUserId,
                IdLugar: newIdLugar,
                CiudadLugar: ciudadLugar,
                NombreLugar: nombreLugar,
                Sector: sector,
                Longitud: clickPosition.lng.toString(),
                Latitud: clickPosition.lat.toString(),
                FechaCreacion: timestamp,
                Direccion: direccion,
                ImagenUrl: imageUrl, // Guardar la URL de la imagen
                IdMarca:marcaSeleccionada
            };

            try {
                const marcaRef = doc(db, "marca", marcaSeleccionada);
                const lugarRef = doc(collection(marcaRef, "lugar"), newIdLugar);
                await setDoc(lugarRef, newData);

                // Guardar los datos del lugar en Firestore
                await setDoc(doc(db, "lugar", newIdLugar), newData);
                closeModal();
                fetchLocations();
                window.location.reload();
                toast.success("Registro exitoso.");
            } catch (error) {
                console.error("Error agregando el documento: ", error);
                toast.error("Hubo un problema registrando el lugar.");
            }
        } else {
            toast.error("Por favor selecciona una posición y asegúrate de estar autenticado.");
        }
    };


    const closeModalUpdate = () => {
        setModalIsOpenUpdate(false);
    };




    // Función para abrir el modal con los datos del lugar seleccionado
    const handleMarkerClick = (location) => {
        setSelectedLocation({
            id: location.IdLugar,
            ciudadLugar: location.CiudadLugar,
            sector: location.Sector,
            nombreLugar: location.NombreLugar,
            direccion: location.Direccion,
            Latitud: location.Latitud,
            Longitud: location.Longitud,
            imagen: location.ImagenUrl, // Aquí agregamos la imagen
        });
        setModalIsOpenUpdate(true);
    };

    // Función para manejar la selección del archivo
    const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setImageFile(file);  // Establecer el archivo seleccionado
        }
    };

    const handleEditLocation = async (e) => {
        e.preventDefault();

        const ciudadLugar = selectedLocation.ciudadLugar || '';
        const sector = selectedLocation.sector || '';
        const nombreLugar = selectedLocation.nombreLugar || '';
        const direccionLugar = selectedLocation.direccion || '';
        const latitudLugar = selectedLocation.Latitud || '';
        const longitudLugar = selectedLocation.Longitud || '';
        let imagenLugar = selectedLocation.imagen || ''; // Usar la imagen actual por defecto

        // Si hay una nueva imagen seleccionada, subimos y obtenemos la URL
        if (imageFile) {
            try {
                const storageRef = ref(storage, `imagenesLugares/${selectedLocation.id}`); // Usar el mismo ID para mantener el archivo
                const uploadResult = await uploadBytes(storageRef, imageFile);
                imagenLugar = await getDownloadURL(uploadResult.ref); // Obtener la URL de la nueva imagen
            } catch (error) {
                console.error("Error subiendo la imagen: ", error);
                toast.error("Hubo un problema subiendo la imagen.");
                return;
            }
        }

        if (!ciudadLugar || !nombreLugar || !latitudLugar || !longitudLugar || !sector || !direccionLugar) {
            console.error("Faltan valores: Ciudad, Nombre, Latitud, Longitud o Dirección no están definidos.");
            return;
        }

        try {
            const docRef = doc(db, "lugar", selectedLocation.id);
            await updateDoc(docRef, {
                CiudadLugar: ciudadLugar,
                Sector: sector,
                NombreLugar: nombreLugar,
                Direccion: direccionLugar,
                Latitud: latitudLugar,
                Longitud: longitudLugar,
                ImagenUrl: imagenLugar,  // Asegúrate de actualizar la imagen si es necesario
            });
            window.location.reload();
            setModalIsOpenUpdate(false); // Cerrar modal al actualizar
            console.log("Documento actualizado correctamente");
            fetchLocations();
            toast.success("Documento actualizado correctamente");
        } catch (error) {
            console.error("Error actualizando la ubicación:", error);
            toast.error("Hubo un problema actualizando la ubicación.");
        }
    };



    // Función para abrir el modal de verificación de eliminación
    const openDeleteModal = () => {
        setDeleteModalIsOpen(true);
    };

    // Función para eliminar el lugar después de la verificación
    const handleDeleteLocation = async () => {
        try {
            // Verificar si hay una imagen asociada
            if (selectedLocation.imagen) {
                // Obtener la referencia a la imagen en Firebase Storage
                const imageRef = ref(storage, selectedLocation.imagen);

                // Eliminar la imagen de Firebase Storage
                await deleteObject(imageRef);
                console.log("Imagen eliminada correctamente de Firebase Storage");
            }

            // Eliminar el documento del lugar en Firestore
            const docRef = doc(db, "lugar", selectedLocation.id);
            await deleteDoc(docRef);

            setDeleteModalIsOpen(false); // Cerrar el modal de verificación
            setModalIsOpen(false); // Cerrar el modal de edición
            console.log("Lugar eliminado correctamente");
            fetchLocations(); // Volver a obtener los lugares después de eliminar
            toast.success("Lugar eliminado correctamente");

        } catch (error) {
            console.error("Error eliminando la ubicación:", error);
            toast.error("Hubo un problema al eliminar el lugar.");
        }
    };

    // Función para guardar los datos en localStorage y redirigir
    const redirectToDetailsPage = () => {
        if (selectedLocation) {
            // Guardar los datos del lugar en localStorage
            localStorage.setItem('selectedLocation', JSON.stringify(selectedLocation));
            // Redirigir a la página de detalles (ajusta la URL a la ruta de tu página)
            window.location.href = '/spaceDetails';
        }
    };

    const redirectToDetailsPage2 = () => {
        window.location.href = '/typeSpace';

    };

    // Evento de clic en el mapa
    const ClickHandler = () => {
        useMapEvents({
            click: async (event) => {
                const { lat, lng } = event.latlng;
                setClickPosition({ lat, lng });
                openModal();
                await fetchCity(lat, lng); // Obtener la ciudad al hacer clic
            },
        });
        return null;
    };

    const parroquiasUrbanasQuito = [
        "Belisario Quevedo", "Carcelén", "Centro Histórico", "Chilibulo", "Chillogallo",
        "Chimbacalle", "Cochapamba", "Comité del Pueblo", "Concepción", "Cotocollao",
        "El Condado", "Guamaní", "Iñaquito", "Itchimbía", "Jipijapa", "Kennedy",
        "La Argelia", "La Ecuatoriana", "La Ferroviaria", "La Libertad", "La Mena",
        "Magdalena", "Mariscal Sucre", "Ponceano", "Puengasí", "Quitumbe", "Rumipamba",
        "San Bartolo", "San Juan", "Solanda", "Turubamba"
    ];
    const parroquiasRuralesQuito = [
        "Alangasí", "Amaguaña", "Atahualpa", "Calderón", "Carapungo",
        "Cumbayá", "Checa", "Chongón", "Conocoto", "El Quinche",
        "Gualea", "Guangopolo", "Guayllabamba", "Lloa", "Nanegal",
        "Nanegalito", "Nono", "Pacto", "Perucho", "Pintag",
        "Pomasqui", "Puéllaro", "San Antonio de Pichincha",
        "San José de Minas", "Tababela", "Tumbaco", "Yaruquí", "Zámbiza"
    ];
    const todasLasParroquiasQuito = [...parroquiasUrbanasQuito, ...parroquiasRuralesQuito];

    const fetchCity = async (lat, lng) => {
        try {
            const response = await axios.get(
                `https://nominatim.openstreetmap.org/reverse`,
                {
                    params: {
                        lat,
                        lon: lng,
                        format: 'json',
                    },
                }
            );

            const address = response.data.address;

            // Detectar si es una parroquia de Quito
            const cityOrParish = address.city || address.town || address.village || 'Ciudad desconocida';
            const isParishOfQuito = todasLasParroquiasQuito.includes(cityOrParish);

            // Asignar ciudad
            const city = isParishOfQuito ? "Quito" : cityOrParish;

            setCiudadLugar(city);
            updateSectores(city); // Actualiza la lista de sectores para la ciudad detectada
            setTimeout(() => setIsSearching(false), 3000); // Simula una búsqueda breve

        } catch (error) {
            console.error('Error al obtener la ciudad:', error);
            setCiudadLugar('Error al detectar ciudad');
            setSectores([]);
        }
    };

    const updateSectores = (city) => {
        const sectores = sectoresPorCiudad[city] || [];
        setSectores(sectores);
    };

    const CenterMapOnLocations = ({ locations, city, sector }) => {
        const map = useMap();
        setIsSearching(true); // Indicar que está buscando

        useEffect(() => {

            if (locations.length > 0) {
                const lat = parseFloat(locations[0].Latitud) || 0;
                const lng = parseFloat(locations[0].Longitud) || 0;

                if (!isNaN(lat) && !isNaN(lng)) {
                    const zoom =
                        (city === "todas" && sector === "") ||
                            (city !== "todas" && sector === "")
                            ? 13
                            : 16;

                    map.flyTo([lat, lng], zoom);
                    setTimeout(() => setIsSearching(false), 3000); // Simula una búsqueda breve

                } else {
                    console.error("Coordenadas no válidas para la primera ubicación");
                }
            }
        }, [locations, city, sector, map]);

        return null;
    };

    const [isSearching, setIsSearching] = useState(false);

    const handleSearch = () => {
        setIsSearching(true); // Activa el estado de búsqueda
        // Simular un proceso de búsqueda
        setTimeout(() => {
            setIsSearching(false); // Finaliza el estado de búsqueda
        }, 2000); // Simula 2 segundos de búsqueda
    };
    const handleMarcaChange = (event) => {
        const selectedOptions = Array.from(event.target.selectedOptions, option => option.value);
        setMarcaSeleccionada(selectedOptions);
    };

    useEffect(() => {
        obtenerMarcasUsuario();
    }, []);

    return (
        <div>
            <Navbar />
            <ToastContainer />
            <br /><br /><br />
            <div>
                {marcas.length > 1 ? (
                    <div>
                        <select
                            value={marcaSeleccionada}
                            onChange={handleMarcaChange}
                            multiple
                        >
                            {marcas.map((marca) => (
                                <option key={marca.id} value={marca.id}>
                                    {marca.nombre} {/* Mostrar el nombre de la marca */}
                                </option>
                            ))}
                        </select>

                        <div>
                            {logoSeleccionado && (
                                <img
                                    src={logoSeleccionado}
                                    alt="Logo de la marca seleccionada"
                                    style={{ maxWidth: "100px", marginTop: "10px" }}
                                />
                            )}
                        </div>
                    </div>
                ) : marcas.length === 1 ? (
                    <div>
                        {marcas[0].logo && (
                            <img
                                src={marcas[0].logo}
                                alt="Logo de la marca"

                                className='logo-marca'
                            />
                        )}
                    </div>
                ) : (
                    <p>No tienes marcas asociadas.</p>
                )}
                {/*
                <button onClick={handleSubmit}>Guardar Marca</button>
*/
                }
            </div>
            <div className="input-group-space">

                {/* Selector de ciudades */}
                <div>
                    
                        <label>Provincia:</label>
                        <select className="rounded-select" value={provinciaId} onChange={(e) => setProvinciaId(e.target.value)}>
                            <option value="">Selecciona una provincia</option>
                            {provinciasData.map((prov) => (
                                <option key={prov.id} value={prov.id}>
                                    {prov.name}
                                </option>
                            ))}
                        </select>
                    

                    {ciudades.length > 0 && (
                        <div>
                            <label>Ciudad:</label>
                            <select value={city} onChange={(e) => setCity(e.target.value)} className="rounded-select">
                                <option value="">Selecciona una ciudad</option>
                                {ciudades.map((ciudad) => (
                                    <option key={ciudad.id} value={ciudad.name}>
                                        {ciudad.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                    )}
                </div>
                {city && (
                    <div>
                        <label>Sector:</label>
                        <select
                            className="rounded-select"
                            onChange={(e) => setSector(e.target.value)}
                            value={sector}
                        >
                            <option value="">Todos los sectores</option>
                            {sectoresPorCiudad[city]?.map((sectorName) => (
                                <option key={sectorName} value={sectorName}>
                                    {sectorName}
                                </option>
                            ))}
                        </select>
                    </div>
                )}
                {/* Selector de sectores */}
               
                {/* Botón para buscar */}
                <button
                    className="rounded-button-admin"
                    style={{
                        backgroundColor: isSearching ? "orange" : "",
                        color: isSearching ? "white" : "",
                    }}
                >
                    {isSearching ? "Buscando..." : "Buscar"}
                </button>
            </div>
            <div className='contenedor-principal-space'>

                <div class="columna-1-space">

                    <div>

                        {filteredLocations.length > 0 ? (
                            <MapContainer

                                zoom={13}
                                zoomAnimation={true}
                                zoomAnimationThreshold={4}
                                className="mapaAdmin"
                                onClick={handleMapClick} // Evento para manejar clics en el mapa
                            >
                                <TileLayer
                                    url="https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png"
                                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                />

                                {/* Función para centrar el mapa dinámicamente */}
                                <CenterMapOnLocations
                                    locations={filteredLocations}
                                    city={city}
                                    sector={sector}
                                />

                                {/* Renderizado de los marcadores filtrados */}
                                {filteredLocations.map((location) => {
                                    const lat = parseFloat(location.Latitud);
                                    const lng = parseFloat(location.Longitud);

                                    if (isNaN(lat) || isNaN(lng)) {
                                        console.error(`Latitud o Longitud no válidas para el ID: ${location.id}`);
                                        return null;
                                    }

                                    return (
                                        <Marker
                                            key={location.id}
                                            position={[lat, lng]}
                                            icon={iconoUbicacionPersonalizado}
                                            eventHandlers={{
                                                click: () => handleMarkerClick(location),
                                            }}
                                        />
                                    );
                                })}

                                {/* Mostrar un marcador adicional cuando se hace clic en el mapa */}
                                {clickPosition && (
                                    <Marker position={[clickPosition.lat, clickPosition.lng]} />
                                )}
                                <ClickHandler />
                            </MapContainer>
                        ) : (
                            <MapContainer
                                center={[-0.1807, -78.4678]} // Coordenadas de Quito
                                zoom={13} // Nivel de zoom para Quito
                                zoomAnimation={true}
                                zoomAnimationThreshold={4}
                                className="mapaAdmin"
                                onClick={handleMapClick} // Evento para manejar clics en el mapa
                            >
                                <TileLayer
                                    url="https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png"
                                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                />

                                {/* Mostrar un marcador adicional cuando se hace clic en el mapa */}
                                {clickPosition && (
                                    <Marker position={[clickPosition.lat, clickPosition.lng]} />
                                )}
                                <ClickHandler />
                            </MapContainer>
                        )}



                        <Modal
                            isOpen={modalIsOpen}
                            onRequestClose={closeModal}
                            contentLabel="Registro de Lugar"
                        >
                            <h2>Registrar Lugar</h2>
                            <form onSubmit={handleSubmit}>
                                <div>
                                    <p>Ciudad</p>
                                    <input
                                        type="text"
                                        value={ciudadLugar}
                                        onChange={(e) => setCiudadLugar(e.target.value)}
                                        required
                                    />
                                </div>
                                <div>
                                    <p>Sector</p>
                                    <select
                                        value={sector}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            setSector(value);
                                            setOtroSector(value === "Otro");
                                        }}
                                    >
                                        <option value="">Seleccione un sector</option>
                                        {sectores.map((sec, index) => (
                                            <option key={index} value={sec}>
                                                {sec}
                                            </option>
                                        ))}
                                        <option value="Otro">Otro</option>
                                    </select>
                                </div>

                                {otroSector && (
                                    <div>
                                        <p>Escriba el sector</p>
                                        <input
                                            type="text"
                                            value={sector}
                                            onChange={(e) => setSector(e.target.value)}
                                            placeholder="Ingrese el sector"
                                            required
                                        />
                                    </div>
                                )}

                                <div>
                                    <p>Nombre</p>
                                    <input
                                        type="text"
                                        value={nombreLugar}
                                        onChange={(e) => setNombreLugar(e.target.value)}
                                        required
                                    />
                                </div>

                                {/* Campo para Dirección */}
                                <div>
                                    <p>Dirección</p>
                                    <input
                                        type="text"
                                        value={direccion}
                                        onChange={(e) => setDireccion(e.target.value)}
                                        required
                                    />
                                </div>

                                {/* Campo para Imagen */}
                                <div>
                                    <p>Subir Imagen</p>
                                    <input
                                        type="file"
                                        accept="image/*"
                                        onChange={(e) => setImageFile(e.target.files[0])}
                                        required
                                    />
                                </div>

                                <button type="submit">Registrar</button>
                            </form>
                            <button onClick={closeModal}>Cancelar</button>
                        </Modal>


                        <Modal
                            isOpen={modalIsOpenUpdate}
                            onRequestClose={closeModalUpdate} // Cierra el modal al hacer clic fuera o en el botón
                            contentLabel="Editar Lugar"
                        >
                            <h2>Editar Lugar</h2>
                            {selectedLocation && ( // Verificar que haya una ubicación seleccionada
                                <form onSubmit={handleEditLocation}>
                                    <div>
                                        <p>Ciudad</p>
                                        <input
                                            type="text"
                                            value={selectedLocation.ciudadLugar || ''}
                                            onChange={(e) => setSelectedLocation({ ...selectedLocation, ciudadLugar: e.target.value })}
                                            required
                                        />
                                    </div>

                                    <div>
                                        <p>Sector</p>
                                        <select
                                            value={selectedLocation.sector || ''}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                setSelectedLocation({ ...selectedLocation, sector: value });
                                                setOtroSector(value === "Otro"); // Si selecciona "Otro", habilitar el campo de texto
                                            }}
                                            required
                                        >
                                            <option value="">Seleccione un sector</option>
                                            {sectores.map((sec, index) => (
                                                <option key={index} value={sec}>
                                                    {sec}
                                                </option>
                                            ))}
                                            <option value="Otro">Otro</option> {/* Opción para ingresar un sector personalizado */}
                                        </select>

                                        {/* Si la opción es "Otro", mostramos el campo de texto para escribir el sector */}
                                        {selectedLocation.sector === "Otro" && (
                                            <div>
                                                <p>Especifica el sector</p>
                                                <input
                                                    type="text"
                                                    value={selectedLocation.otroSector || ''}
                                                    onChange={(e) => setSelectedLocation({ ...selectedLocation, otroSector: e.target.value })}
                                                    placeholder="Escribe un sector"
                                                />
                                            </div>
                                        )}
                                    </div>


                                    <div>
                                        <p>Nombre</p>
                                        <input
                                            type="text"
                                            value={selectedLocation.nombreLugar || ''}
                                            onChange={(e) => setSelectedLocation({ ...selectedLocation, nombreLugar: e.target.value })}
                                            required
                                        />
                                    </div>

                                    <div>
                                        <p>Dirección</p>
                                        <input
                                            type="text"
                                            value={selectedLocation.direccion || ''}
                                            onChange={(e) => setSelectedLocation({ ...selectedLocation, direccion: e.target.value })}
                                            required
                                        />
                                    </div>

                                    <div>
                                        <p>Imagen</p>
                                        <input
                                            type="file"
                                            accept="image/*"
                                            onChange={handleImageChange} // Llamar a la función cuando se seleccione un archivo
                                        />

                                        {/* Mostrar la imagen actual si existe */}
                                        {selectedLocation && selectedLocation.imagen && (
                                            <div>
                                                <p>Imagen actual:</p>
                                                <img
                                                    src={selectedLocation.imagen}
                                                    alt="Lugar"
                                                    style={{ width: '100px', height: '100px' }}
                                                />
                                            </div>
                                        )}

                                        {/* Aquí puedes agregar otras partes del formulario según sea necesario */}
                                    </div>

                                    <button type="submit">Actualizar</button>

                                    <button
                                        style={{ marginTop: '20px', backgroundColor: 'blue', color: 'white' }}
                                        onClick={redirectToDetailsPage}
                                    >
                                        Agregar Espacios
                                    </button>

                                    {usuario?.uid === 'eeQjHSdTGZgYWcuWQ7Bbz77XAMr1' && (
                                        <button
                                            style={{ marginTop: '20px', backgroundColor: 'red', color: 'white' }}
                                            onClick={() => openDeleteModal(selectedLocation)}
                                        >
                                            Eliminar
                                        </button>
                                    )}

                                </form>
                            )}
                            <button onClick={closeModalUpdate}>Cancelar</button>
                        </Modal>
                        <Modal
                            isOpen={deleteModalIsOpen}
                            onRequestClose={closeDeleteModal}
                            contentLabel="Confirmar Eliminación"
                        >
                            <h2>¿Estás seguro que deseas eliminar este lugar?</h2>

                            {/* Mostrar los detalles del lugar seleccionado */}
                            {selectedLocation && (
                                <div>
                                    <p><strong>Nombre del Lugar:</strong> {selectedLocation.nombreLugar}</p>
                                    <p><strong>Ciudad:</strong> {selectedLocation.ciudadLugar}</p>
                                    <p><strong>Sector:</strong> {selectedLocation.sector}</p>
                                    <p><strong>Coordenadas:</strong> {selectedLocation.Latitud}, {selectedLocation.Longitud}</p>
                                </div>
                            )}

                            <p>Esta acción no se puede deshacer.</p>

                            <button
                                style={{ backgroundColor: 'red', color: 'white' }}
                                onClick={handleDeleteLocation} // Función para eliminar el lugar
                            >
                                Confirmar Eliminación
                            </button>
                            <button onClick={closeDeleteModal}>Cancelar</button>
                        </Modal>
                    </div>
                    <div className='btn-contenedor'>

                        <button className='btn-spaces' onClick={redirectToDetailsPage2}>
                            Agregar Tipo de Espacio
                        </button>
                    </div>
                </div>

            </div>

            <div>
                <div className="table-container-space-admin">
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <thead>
                            <tr>
                                <th className="table-header">Nombre del Lugar</th>
                                <th className="table-header">Ciudad</th>
                                <th className="table-header">Sector</th>

                                <th className="table-header">Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {lugares.length > 0 ? (
                                lugares.map(location => (
                                    <tr key={location.id} className="table-row">
                                        <td className="table-cell">{location.NombreLugar}</td>
                                        <td className="table-cell">{location.CiudadLugar}</td>
                                        <td className="table-cell">{location.Sector}</td>

                                        <td className="table-cell">
                                            <button onClick={() => handleMarkerClick(location)}>Gestionar</button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="7" style={{ textAlign: 'center', padding: '20px' }}>
                                        No se encontraron ubicaciones.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

        </div>

    );

};


export default Space;
